var _circle, _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogbookRebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "#12908D",
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.513 7.214c-1.19-.365-2.3-.206-3.12.05-.83.26-1.393 1.05-1.393 1.941v16.889c0 .029.001.057.004.086.076-1.214 1.4-2.18 3.021-2.18 1.368 0 2.524.688 2.898 1.633V9.16c0-.897-.573-1.689-1.41-1.946z",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 26.292,
    rx: 3,
    ry: 2.292,
    fill: "#4A5862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogbookRebar);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconLogbookRebar.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };